import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Layout } from './components/layout';
import {
  Home, About, Experience, Skills, Projects, Education,
  Blogs, BlogPost, Contact, Privacy,
  AdminLogin, Dashboard, BlogEditor, BlogsManagement,
  ContactsManagement, UsersManagement, ApiKeysManagement, Settings
} from './pages';
import ScrollToTop from './components/common/ScrollToTop';

function App() {
  const location = useLocation();

  // Check if current route is admin
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      <ScrollToTop />
      {isAdminRoute ? (
        // Admin routes without main layout
        <Routes location={location} key={location.pathname}>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/blogs" element={<BlogsManagement />} />
          <Route path="/admin/blogs/new" element={<BlogEditor />} />
          <Route path="/admin/blogs/edit/:id" element={<BlogEditor />} />
          <Route path="/admin/contacts" element={<ContactsManagement />} />
          <Route path="/admin/users" element={<UsersManagement />} />
          <Route path="/admin/api-keys" element={<ApiKeysManagement />} />
          <Route path="/admin/settings" element={<Settings />} />
        </Routes>
      ) : (
        // Public routes with main layout
        <Layout>
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/skills" element={<Skills />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/education" element={<Education />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blogs/:slug" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Privacy />} />
            </Routes>
          </AnimatePresence>
        </Layout>
      )}
    </>
  );
}

export default App;
